/**
 * Générateur — Vocabulaire des probabilités.
 * Attendu ID : 166 | Niveau : 4ème | Domaine : Probabilités (descripteur 15)
 *
 * Objectif O3 : « Il utilise le vocabulaire des probabilités : expérience
 * aléatoire, issues, événement, probabilité, événement certain, événement
 * impossible, événement contraire. »
 *
 * Source : doc prof « TANOED EXERCISEUR OGD/FONCTIONS 4EME ». O3 est MUET en
 * exercices texte → BANQUE construite sur l'image « Exemples de réussite »
 * page 4 (urne de boules blanches/grises numérotées : issues selon la couleur,
 * selon le numéro, événement certain, événement impossible). Plan de cartes
 * validé le 2026-07-14 : « Les issues de l'expérience », « Certain, impossible
 * ou possible ? », « L'événement contraire », « Le bon mot ».
 *
 * Revue 2026-09-23 (vague 3), décisions du coordinateur appliquées en mode
 * auto. Attendu de fin de 4e (Eduscol, attendus de fin d'année, p. 5) : la
 * ligne ci-dessus. Exemple de réussite : une urne de 12 boules grises ou
 * blanches, numéros RÉPÉTÉS (1, 2, 4, 5, 6 : le 3 manque), « Si on s'intéresse
 * à la couleur de la boule, quelles sont les issues possibles ? Si on
 * s'intéresse au numéro écrit sur la boule, quelles sont les issues
 * possibles ? Donne un événement certain de se réaliser. Donne un événement
 * impossible. » Cours (19Proba) : « Un évènement est constitué d'une ou
 * plusieurs issues » ; contraire = « l'ensemble de toutes les issues
 * n'appartenant pas à A » (« l'événement constitué des issues 3 ; 4 ; 5 et
 * 6 ») ; certain « Obtenir un numéro inférieur à 10 », impossible « Obtenir une
 * boule verte ». Absents du cours : « possible » comme catégorie,
 * « strictement ». Aucune carte ne calcule une probabilité (167 à 170) :
 * conforme, gardé ainsi. AUCUN solveur test-side ne couvre 166 (les mentions
 * d'un solveur de l'en-tête d'origine étaient fausses, retirées) : chaque
 * réponse est recalculée dans le gen par un second chemin (throw), et le test
 * jetable tmp-revue-166 relit chaque événement dans la phrase affichée.
 *   - Rappel brouillon : AUCUN (décision) ; le vocabulaire et la nature d'un
 *     événement se lisent de tête.
 *   - Figure : urne de l'exemple de réussite (svgUrneNumeros, ajoutée à
 *     probas.js sans toucher svgUrneVar) : 6 à 12 boules de deux couleurs, 3 à
 *     6 numéros différents RÉPÉTÉS, au moins un numéro manquant sous le plus
 *     grand (le 3 de l'exemple), boules mélangées ; paires de couleurs
 *     contrastées (plus de rouge avec orange ou vert) ; attribut alt qui donne
 *     la composition. Le texte ne dit plus « numérotées de 1 à N » : la figure
 *     est la donnée.
 *   - issues_texte_trou_saisie : la définition « Une issue est un résultat
 *     possible » sort de l'énoncé ; aucun trou dont la réponse est écrite dans
 *     l'énoncé (le nombre de boules n'est plus la réponse, 100 % avant) ; les
 *     deux lignes (couleur, numéro) dans un ordre tiré, le premier trou n'est
 *     plus toujours 2 (100 % avant).
 *   - issues_texte_trou_drag REMPLACÉE par issues_qcm_multiple (la paire
 *     « {{c1}} et {{c2}} » refusait l'ordre inverse, 100 %) : « On s'intéresse
 *     au numéro écrit sur la boule. Sélectionne les k issues possibles. »,
 *     parmi les numéros présents, un ou deux numéros absents (numero_absent) et
 *     une couleur (couleur_pour_numero), le nombre de réponses annoncé.
 *   - issues_qcm_unique : variante « nombre d'issues » gardée, sur l'urne à
 *     numéros répétés, quatre choix toujours (trois choix dans 43,4 % des
 *     tirages avant), la clé n'est plus la plus grande (100 % avant) ;
 *     distracteurs issues_comptees_en_boules, couleur_pour_numero,
 *     plus_grand_numero (le numéro manquant, comme le 3 de l'exemple) ; variante
 *     « pourquoi est-ce une expérience aléatoire » SORTIE (distracteurs
 *     absurdes). Résiduel mesuré, mode auto, À ARBITRER : avec ces trois
 *     familles la clé est toujours la deuxième plus petite valeur (2 < clé <
 *     plus grand numéro, clé < nombre de boules) ; parade possible, non
 *     appliquée faute d'erreur attestée : une quatrième famille de valeur
 *     inférieure à la clé.
 *   - Cartes « nature » : un sac de jetons numérotés de 1 à N, de deux
 *     couleurs (les premiers numéros d'une couleur, les autres de l'autre),
 *     pour les événements par la couleur du cours (« obtenir un jeton vert »)
 *     ; « strictement » n'est plus écrit : « inférieur à », « supérieur à »
 *     comme le cours, et une borne n'est tirée que si la lecture stricte et la
 *     lecture large donnent la même nature (plus d'ambiguïté « compris
 *     entre »). Libellé de carte « Certain, impossible ou possible ? » gardé
 *     par le correcteur, puis renommé « Certain ou impossible ? » par le
 *     coordinateur : les catégories élève ne disent plus « possible ».
 *   - nature_qcm_unique : la nature visée est tirée d'abord, un tiers chacune
 *     (la clé n'était jamais « Ni certain ni impossible », 0 %) ; impossibles
 *     aussi par la couleur ; quand la clé est « Ni certain ni impossible »,
 *     l'événement est le plus souvent très probable (piège
 *     certain_pour_tres_probable) ou rare (piège impossible_pour_rare).
 *   - nature_classer : catégories « Certain », « Impossible », « Ni certain
 *     ni impossible » (plus de « possible ») ; de 1 à 3 événements par
 *     catégorie, 5 à 7 en tout (2 + 2 + 2 fixe avant).
 *   - nature_tableau_vf : lignes « … est certain. » / « … est impossible. »
 *     seulement (un événement certain dit « possible » était compté faux,
 *     26,3 %) ; quatre événements différents (le même événement revenait sur
 *     deux lignes, 100 %) ; une à trois lignes vraies ; une fausse au moins
 *     est un piège nommé (certain_pour_tres_probable, impossible_pour_rare),
 *     les autres sont tirées au hasard (le même piège revenait sinon dans
 *     presque tous les tableaux).
 *   - contraire_qcm_unique : la forme du cours, le contraire donné par ses
 *     issues (« Les issues 3 ; 4 ; 5 et 6 ») ; un dé à six faces, huit ou dix
 *     jetons ; distracteurs de la MÊME famille (la clé se repérait sans évaluer
 *     dans 90,1 % des tirages) : contraire_partiel (une issue oubliée),
 *     contraire_voisin (le contraire de l'événement voisin : la borne incluse,
 *     ou « ne pas obtenir » le numéro d'à côté), meme_sens (pour une borne :
 *     « inférieur » gardé, borne exclue) ou evenement_pour_issue (une seule
 *     issue). L'exemple du cours (dé, « inférieur ou égal à 2 ») n'est jamais
 *     tiré : il est réservé au coup de pouce.
 *   - contraire_tableau_vf : quatre événements différents, un seul par ligne
 *     (deux lignes sur le même événement, 83,3 % avant) ; une à trois vraies ;
 *     les deux lignes génériques « peuvent / ne peuvent pas se réaliser en
 *     même temps » (l'une négation de l'autre) sortent ; fausses nommées.
 *   - Carte « Le bon mot » SORTIE, mode auto, À ARBITRER (vocab_relier,
 *     vocab_qcm_unique) : définitions nues, dont une FAUSSE (« un événement :
 *     un ensemble de plusieurs issues », 67,6 % des relier), un distracteur
 *     vrai lui aussi (20,2 % des QCM), quatre sources sans leurre ; l'attendu
 *     dit « utilise », servi par les autres cartes en situation.
 *   - Contrat des distracteurs exporté (REGLES_DISTRACTEURS_QCM), codes dans
 *     _meta.params.distracteurs.
 * Huit formats (dix avant), dont quatre QCM (trois à réponse unique, un multiple).
 */
import {
    randomChoice, randInt, shuffle,
    makeQcm, makeVraiFaux, makeTexteTrou, makeClasser,
} from '../../../utils';
import { elUrneNumeros, cap } from './probas';

const ATTENDU_ID = 166;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_ISSUES = "Les issues de l'expérience";
// Ancien libellé « Certain, impossible ou possible ? » : « possible » n'est
// plus une catégorie (absent du cours), le nom de la carte suit (coordinateur,
// 2026-09-23).
const L_NATURE = 'Certain ou impossible ?';
const L_CONTRAIRE = "L'événement contraire";

const intervalle = (a, b) => Array.from({ length: Math.max(0, b - a + 1) }, (_, i) => a + i);
const trie = (l) => [...l].sort((a, b) => a - b);
const memeEnsemble = (a, b) => trie(a).join(',') === trie(b).join(',');

/** « 1, 2 et 5 » (virgules et « et »). */
const listeEt = (l, sep = ', ') => (l.length === 1 ? String(l[0]) : `${l.slice(0, -1).join(sep)} et ${l[l.length - 1]}`);

// ═════════════════════════════════════════════════════════════
// CARTE « Les issues de l'expérience » (urne de l'exemple de réussite)
// ═════════════════════════════════════════════════════════════

// Paires de couleurs contrastées (adjectifs féminins, clés de COULEURS_4E).
const PAIRES_BOULES = [
    ['grise', 'blanche'], ['bleue', 'jaune'], ['noire', 'blanche'],
    ['rouge', 'bleue'], ['verte', 'jaune'], ['violette', 'blanche'],
];
const pl = (c) => `${c}s`;

// L'urne de l'exemple de réussite, jamais tirée (réservée au coup de pouce).
const URNE_EXEMPLE = [1, 1, 1, 2, 2, 2, 2, 4, 4, 5, 6, 6].join(',');

/**
 * 6 à 12 boules de deux couleurs (au moins 2 de chaque), k = 3 à 6 numéros
 * différents, le plus grand au-dessus de k (un numéro au moins manque sous lui),
 * au moins deux boules de plus que de numéros (des numéros répétés), le nombre
 * de boules différent du plus grand numéro.
 */
const tirerUrne = () => {
    for (let essai = 0; essai < 100; essai++) {
        const [c1, c2] = shuffle(randomChoice(PAIRES_BOULES));
        const k = randInt(3, 6);
        const max = randInt(k + 1, 9);
        const numeros = trie([...shuffle(intervalle(1, max - 1)).slice(0, k - 1), max]);
        const N = randInt(Math.max(6, k + 2), 12);
        if (N === max) continue;
        const tirage = shuffle([...numeros, ...Array.from({ length: N - k }, () => randomChoice(numeros))]);
        if (N === 12 && trie(tirage).join(',') === URNE_EXEMPLE) continue;
        const n1 = randInt(2, N - 2);
        const couleurs = shuffle([...Array(n1).fill(c1), ...Array(N - n1).fill(c2)]);
        return { c1, c2, n1, N, k, max, numeros, boules: tirage.map((numero, i) => ({ couleur: couleurs[i], numero })) };
    }
    // Repli déterministe vérifié : 9 boules grises et blanches, numéros 1, 2, 3, 5
    // (le 4 manque) : 4 issues pour le numéro, 2 pour la couleur, plus grand numéro 5.
    const numerosRepli = [1, 5, 2, 1, 3, 5, 2, 1, 3];
    const couleursRepli = ['grise', 'blanche', 'grise', 'blanche', 'blanche', 'grise', 'grise', 'grise', 'blanche'];
    return {
        c1: 'grise', c2: 'blanche', n1: 5, N: 9, k: 4, max: 5, numeros: [1, 2, 3, 5],
        boules: numerosRepli.map((numero, i) => ({ couleur: couleursRepli[i], numero })),
    };
};

/** Second chemin : l'urne relue boule par boule (issues, couleurs, nombre de boules). */
const verifierUrne = (u) => {
    const nums = trie([...new Set(u.boules.map((b) => b.numero))]);
    const cols = new Set(u.boules.map((b) => b.couleur));
    if (u.boules.length !== u.N || nums.join(',') !== u.numeros.join(',') || nums.length !== u.k
        || cols.size !== 2 || Math.max(...nums) !== u.max || u.max <= u.k || u.N <= u.k + 1
        || u.boules.filter((b) => b.couleur === u.c1).length !== u.n1) {
        throw new Error(`gen_166 : urne incohérente ${JSON.stringify(u.boules)}`);
    }
};

const descUrne = (u) => `<p>Une urne contient des boules ${pl(u.c1)} et des boules ${pl(u.c2)}, `
    + 'numérotées comme sur la figure. On tire une boule au hasard.</p>';

const figureUrne = (u) => {
    const numerosDe = (c) => trie(u.boules.filter((b) => b.couleur === c).map((b) => b.numero));
    const n2 = u.N - u.n1;
    return elUrneNumeros(u.boules,
        `Urne de ${u.N} boules : ${u.n1} ${pl(u.c1)} numérotées ${listeEt(numerosDe(u.c1))}, `
        + `et ${n2} ${pl(u.c2)} numérotées ${listeEt(numerosDe(u.c2))}.`);
};

const genIssuesSaisie = () => {
    const u = tirerUrne();
    verifierUrne(u);
    // Les deux lignes dans un ordre tiré : le premier trou n'est plus toujours 2.
    const lignes = shuffle([
        'Si on s\'intéresse à la couleur, il y a {{2}} issues.',
        `Si on s'intéresse au numéro, il y a {{${u.k}}} issues.`,
    ]);
    const payload = makeTexteTrou(lignes.join('\n'),
        `${descUrne(u)}<p><b>Complète le nombre d'issues dans chaque cas.</b></p>`,
        { ...opts(L_ISSUES), mode: 'saisie', strict: false });
    payload.elements_additionnels = figureUrne(u);
    payload._meta.params = { N: u.N, k: u.k, max: u.max, numeros: u.numeros, ordre: lignes[0].includes('couleur') ? 'couleur' : 'numero' };
    return payload;
};

const genIssuesQcmMultiple = () => {
    const u = tirerUrne();
    verifierUrne(u);
    const absents = intervalle(1, u.max).filter((x) => !u.numeros.includes(x));
    // Un numéro absent, deux quand il y en a deux et que cela tient en huit choix.
    const nbAbsents = u.k <= 5 && absents.length >= 2 && randInt(0, 1) === 0 ? 2 : 1;
    const numerosAbsents = shuffle(absents).slice(0, nbAbsents);
    const couleur = cap(randomChoice([u.c1, u.c2]));
    const bonnes = u.numeros.map(String);
    const choix = [...bonnes, ...numerosAbsents.map(String), couleur];
    // Second chemin : chaque numéro proposé comme bon est sur une boule, aucun absent n'y est.
    if (!bonnes.every((x) => u.boules.some((b) => String(b.numero) === x))
        || numerosAbsents.some((x) => u.boules.some((b) => b.numero === x)) || choix.length > 8) {
        throw new Error('gen_166 : QCM multiple des issues');
    }
    const payload = makeQcm(choix, bonnes,
        `${descUrne(u)}<p><b>On s'intéresse au numéro écrit sur la boule. Sélectionne les ${u.k} issues possibles.</b></p>`,
        opts(L_ISSUES), true);
    payload.elements_additionnels = figureUrne(u);
    payload._meta.params = {
        N: u.N, k: u.k, numeros: u.numeros, absents: numerosAbsents,
        distracteurs: [...numerosAbsents.map(() => 'numero_absent'), 'couleur_pour_numero'],
    };
    return payload;
};

const genIssuesQcm = () => {
    const u = tirerUrne();
    verifierUrne(u);
    const options = [
        { code: null, v: u.k },
        { code: 'issues_comptees_en_boules', v: u.N },
        { code: 'couleur_pour_numero', v: 2 },
        { code: 'plus_grand_numero', v: u.max },
    ];
    if (new Set(options.map((o) => o.v)).size !== 4) throw new Error('gen_166 : QCM des issues');
    const choix = options.map((o) => String(o.v));
    const payload = makeQcm(choix, choix[0],
        `${descUrne(u)}<p><b>Combien y a-t-il d'issues si on s'intéresse au numéro écrit sur la boule ?</b></p>`,
        opts(L_ISSUES));
    payload.elements_additionnels = figureUrne(u);
    payload._meta.params = { N: u.N, k: u.k, max: u.max, numeros: u.numeros, distracteurs: options.slice(1).map((o) => o.code) };
    return payload;
};

// ═════════════════════════════════════════════════════════════
// Cartes « nature » : un sac de jetons numérotés, de deux couleurs
// ═════════════════════════════════════════════════════════════

// Adjectifs masculins (jeton) : singulier, pluriel ; la couleur absente sert
// l'événement impossible « par la couleur » du cours.
const PAIRES_JETONS = [
    { a: ['rouge', 'rouges'], b: ['bleu', 'bleus'], absente: 'vert' },
    { a: ['vert', 'verts'], b: ['jaune', 'jaunes'], absente: 'rouge' },
    { a: ['noir', 'noirs'], b: ['blanc', 'blancs'], absente: 'bleu' },
    { a: ['bleu', 'bleus'], b: ['jaune', 'jaunes'], absente: 'noir' },
];

/** N jetons numérotés de 1 à N ; les numéros 1 à a d'une couleur, les autres de l'autre. */
const tirerSac = () => {
    const N = randInt(6, 10);
    return { N, a: randInt(2, N - 2), cols: randomChoice(PAIRES_JETONS) };
};

const descSac = (S) => `<p>Un sac contient ${S.N} jetons numérotés de 1 à ${S.N}. `
    + `Les jetons numérotés ${S.a === 2 ? '1 et 2' : `de 1 à ${S.a}`} sont ${S.cols.a[1]}, les autres sont ${S.cols.b[1]}. `
    + 'On tire un jeton au hasard.</p>';

// Un événement : { code, s | x | c }. `pred` est la lecture du cours ; `autre`
// la lecture qu'un élève peut en faire (stricte ↔ large) : une borne n'est
// retenue que si les deux lectures donnent la même nature.
const EVENEMENTS = {
    inf: { phrase: (e) => `obtenir un numéro inférieur à ${e.s}`, pred: (k, e) => k < e.s, autre: (k, e) => k <= e.s },
    infeg: { phrase: (e) => `obtenir un numéro inférieur ou égal à ${e.s}`, pred: (k, e) => k <= e.s },
    sup: { phrase: (e) => `obtenir un numéro supérieur à ${e.s}`, pred: (k, e) => k > e.s, autre: (k, e) => k >= e.s },
    supeg: { phrase: (e) => `obtenir un numéro supérieur ou égal à ${e.s}`, pred: (k, e) => k >= e.s },
    egal: { phrase: (e) => `obtenir le numéro ${e.x}`, pred: (k, e) => k === e.x },
    pair: { phrase: () => 'obtenir un numéro pair', pred: (k) => k % 2 === 0 },
    impair: { phrase: () => 'obtenir un numéro impair', pred: (k) => k % 2 === 1 },
    couleur: { phrase: (e, S) => `obtenir un jeton ${e.c === 'a' ? S.cols.a[0] : S.cols.b[0]}`, pred: (k, e, S) => (e.c === 'a' ? k <= S.a : k > S.a) },
    deux_couleurs: { phrase: (e, S) => `obtenir un jeton ${S.cols.a[0]} ou ${S.cols.b[0]}`, pred: () => true },
    couleur_absente: { phrase: (e, S) => `obtenir un jeton ${S.cols.absente}`, pred: () => false },
};

const ensembleDe = (e, S, lecture = 'pred') => {
    const def = EVENEMENTS[e.code];
    const f = def[lecture] || def.pred;
    return intervalle(1, S.N).filter((k) => f(k, e, S));
};
const natureDe = (e, S, lecture) => {
    const n = ensembleDe(e, S, lecture).length;
    return n === 0 ? 'impossible' : n === S.N ? 'certain' : 'ni';
};
const phraseDe = (e, S) => EVENEMENTS[e.code].phrase(e, S);

/** Second chemin : la nature attendue, la même sous la lecture stricte et la lecture large. */
const verifierNature = (e, S, attendue) => {
    if (natureDe(e, S) !== attendue || natureDe(e, S, 'autre') !== attendue) {
        throw new Error(`gen_166 : « ${phraseDe(e, S)} » n'est pas ${attendue} (N = ${S.N})`);
    }
};

// Viviers par nature, construits pour le sac S. Chaque entrée porte son piège
// nommé quand il y en a un.
const certains = (S) => [
    { code: 'inf', s: randomChoice([10, 12, 15, 20, S.N + 1, S.N + 2].filter((s) => s > S.N)) },
    { code: 'infeg', s: randomChoice([10, 12, 20, S.N, S.N + 1].filter((s) => s >= S.N)) },
    { code: 'supeg', s: 1 },
    { code: 'sup', s: 0 },
    { code: 'deux_couleurs' },
];
const impossibles = (S) => [
    { code: 'sup', s: randomChoice([12, 15, 20, S.N + 1, S.N + 2].filter((s) => s > S.N)) },
    { code: 'supeg', s: S.N + randInt(1, 5) },
    { code: 'egal', x: randomChoice([0, 12, 15, 20, S.N + 1, S.N + 3].filter((x) => x === 0 || x > S.N)) },
    { code: 'couleur_absente' },
    { code: 'infeg', s: 0 },
];
// Très probables : il manque une issue, ou deux quand il y a au moins 8 jetons.
const tresProbables = (S) => [
    { code: 'infeg', s: S.N - 1, piege: 'certain_pour_tres_probable' },
    { code: 'supeg', s: 2, piege: 'certain_pour_tres_probable' },
    ...(S.N >= 8 ? [
        { code: 'infeg', s: S.N - 2, piege: 'certain_pour_tres_probable' },
        { code: 'supeg', s: 3, piege: 'certain_pour_tres_probable' },
    ] : []),
];
const rares = (S) => [
    { code: 'egal', x: randInt(1, S.N), piege: 'impossible_pour_rare' },
    { code: 'infeg', s: 1, piege: 'impossible_pour_rare' },
    { code: 'supeg', s: S.N, piege: 'impossible_pour_rare' },
];
const ordinaires = (S) => [
    { code: 'pair' }, { code: 'impair' },
    { code: 'couleur', c: randomChoice(['a', 'b']) },
    { code: 'inf', s: randInt(3, S.N - 1) },
    { code: 'sup', s: randInt(2, S.N - 2) },
];
const nis = (S) => [...tresProbables(S), ...rares(S), ...ordinaires(S)];

const NATURES = { certain: 'Certain', impossible: 'Impossible', ni: 'Ni certain ni impossible' };

const genNatureQcm = () => {
    const S = tirerSac();
    const cible = randomChoice(['certain', 'impossible', 'ni']);
    let e;
    if (cible === 'certain') e = randomChoice(certains(S));
    else if (cible === 'impossible') e = randomChoice(impossibles(S));
    else {
        // Le plus souvent un piège nommé : très probable ou rare.
        const r = randInt(0, 2);
        e = randomChoice(r === 0 ? tresProbables(S) : r === 1 ? rares(S) : ordinaires(S));
    }
    verifierNature(e, S, cible);
    const choix = [NATURES.certain, NATURES.impossible, NATURES.ni];
    const payload = makeQcm(choix, NATURES[cible],
        `${descSac(S)}<p><b>L'événement « ${phraseDe(e, S)} » est-il certain, impossible, ou ni certain ni impossible ?</b></p>`,
        opts(L_NATURE));
    payload._meta.params = { N: S.N, a: S.a, evenement: phraseDe(e, S), nature: cible, distracteurs: e.piege ? [e.piege] : [] };
    return payload;
};

/** Événements distincts (phrases distinctes) tirés d'un vivier, `combien` au plus. */
const tirerDistincts = (vivier, S, combien, prises) => {
    const out = [];
    shuffle(vivier).forEach((e) => {
        const p = phraseDe(e, S);
        if (out.length < combien && !prises.has(p)) {
            prises.add(p);
            out.push(e);
        }
    });
    return out;
};

const genNatureClasser = () => {
    for (let essai = 0; essai < 60; essai++) {
        const S = tirerSac();
        const nb = { certain: randInt(1, 3), impossible: randInt(1, 3), ni: randInt(1, 3) };
        const total = nb.certain + nb.impossible + nb.ni;
        if (total < 5 || total > 7) continue;
        const prises = new Set();
        const pris = {
            certain: tirerDistincts(certains(S), S, nb.certain, prises),
            impossible: tirerDistincts(impossibles(S), S, nb.impossible, prises),
            ni: tirerDistincts(nis(S), S, nb.ni, prises),
        };
        if (Object.keys(nb).some((n) => pris[n].length !== nb[n])) continue;
        Object.keys(pris).forEach((n) => pris[n].forEach((e) => verifierNature(e, S, n)));
        const payload = makeClasser(
            Object.keys(NATURES).map((n) => ({ name: NATURES[n], items: pris[n].map((e) => phraseDe(e, S)) })),
            `${descSac(S)}<p><b>Classe chaque événement : certain, impossible, ou ni certain ni impossible.</b></p>`,
            opts(L_NATURE));
        payload._meta.params = { N: S.N, a: S.a, repartition: nb };
        return payload;
    }
    // Repli déterministe vérifié : 8 jetons, 1 à 3 rouges, 4 à 8 bleus.
    const S = { N: 8, a: 3, cols: PAIRES_JETONS[0] };
    const pris = {
        certain: [{ code: 'inf', s: 10 }, { code: 'deux_couleurs' }],
        impossible: [{ code: 'couleur_absente' }, { code: 'egal', x: 12 }],
        ni: [{ code: 'infeg', s: 7 }, { code: 'egal', x: 5 }],
    };
    Object.keys(pris).forEach((n) => pris[n].forEach((e) => verifierNature(e, S, n)));
    const payload = makeClasser(
        Object.keys(NATURES).map((n) => ({ name: NATURES[n], items: pris[n].map((e) => phraseDe(e, S)) })),
        `${descSac(S)}<p><b>Classe chaque événement : certain, impossible, ou ni certain ni impossible.</b></p>`,
        opts(L_NATURE));
    payload._meta.params = { N: 8, a: 3, repartition: { certain: 2, impossible: 2, ni: 2 } };
    return payload;
};

// V/F : quatre événements différents, une ligne chacun, « … est certain. » ou
// « … est impossible. » seulement.
const genNatureVF = () => {
    const S = tirerSac();
    const nbV = randInt(1, 3);
    const prises = new Set();
    // Vraies : un événement certain dit certain, un impossible dit impossible.
    const vraies = [];
    const vc = tirerDistincts(certains(S), S, 2, prises).map((e) => ({ e, mot: 'certain', nat: 'certain' }));
    const vi = tirerDistincts(impossibles(S), S, 2, prises).map((e) => ({ e, mot: 'impossible', nat: 'impossible' }));
    shuffle([...vc, ...vi]).forEach((l) => { if (vraies.length < nbV) vraies.push(l); });
    // Fausses : une ligne piège nommée d'abord (très probable dit certain, ou
    // rare dit impossible), les autres tirées au hasard parmi les pièges
    // restants et les événements ordinaires dits certains ou impossibles (sans
    // cela, le même piège revenait dans presque tous les tableaux).
    const fausses = [];
    const pieges = shuffle([
        ...tirerDistincts(tresProbables(S), S, 1, prises).map((e) => ({ e, mot: 'certain', nat: 'ni' })),
        ...tirerDistincts(rares(S), S, 1, prises).map((e) => ({ e, mot: 'impossible', nat: 'ni' })),
    ]);
    const autres = tirerDistincts(ordinaires(S), S, 2, prises)
        .map((e) => ({ e, mot: randomChoice(['certain', 'impossible']), nat: 'ni' }));
    [pieges[0], ...shuffle([...pieges.slice(1), ...autres])].filter(Boolean)
        .forEach((l) => { if (fausses.length < 4 - nbV) fausses.push(l); });
    const lignes = shuffle([...vraies, ...fausses]);
    if (lignes.length !== 4) throw new Error('gen_166 : V/F nature incomplet');
    lignes.forEach((l) => verifierNature(l.e, S, l.nat));
    const payload = makeVraiFaux(
        lignes.map((l) => `L'événement « ${phraseDe(l.e, S)} » est ${l.mot}.`),
        lignes.map((l) => (l.nat === l.mot ? 0 : 1)),
        `${descSac(S)}<p><b>Vrai ou faux ?</b></p>`,
        opts(L_NATURE));
    payload._meta.params = {
        N: S.N, a: S.a, nbV,
        distracteurs: lignes.filter((l) => l.nat !== l.mot && l.e.piege).map((l) => l.e.piege),
    };
    return payload;
};

// ═════════════════════════════════════════════════════════════
// CARTE « L'événement contraire »
// ═════════════════════════════════════════════════════════════

// Univers sans couleur : le dé du cours ou huit jetons.
const UNIVERS_CONTRAIRE = [
    { N: 6, intro: '<p>On lance un dé à six faces et on regarde le nombre obtenu.</p>', mot: 'nombre' },
    { N: 8, intro: '<p>On tire au hasard un jeton dans un sac de 8 jetons numérotés de 1 à 8.</p>', mot: 'numéro' },
    { N: 10, intro: '<p>On tire au hasard un jeton dans un sac de 10 jetons numérotés de 1 à 10.</p>', mot: 'numéro' },
];

const phraseA = (A, U) => {
    switch (A.code) {
        case 'infeg': return `obtenir un ${U.mot} inférieur ou égal à ${A.s}`;
        case 'supeg': return `obtenir un ${U.mot} supérieur ou égal à ${A.s}`;
        case 'egal': return `obtenir le ${U.mot} ${A.x}`;
        case 'pair': return `obtenir un ${U.mot} pair`;
        case 'impair': return `obtenir un ${U.mot} impair`;
        default: return '';
    }
};
const ensembleA = (A, U) => intervalle(1, U.N).filter((k) => {
    switch (A.code) {
        case 'infeg': return k <= A.s;
        case 'supeg': return k >= A.s;
        case 'egal': return k === A.x;
        case 'pair': return k % 2 === 0;
        case 'impair': return k % 2 === 1;
        default: return false;
    }
});
const complementDe = (ens, U) => intervalle(1, U.N).filter((k) => !ens.includes(k));

/** « Les issues 3 ; 4 ; 5 et 6 », « L'issue 4 » (forme du cours). */
const issuesTexte = (ens) => {
    const l = trie(ens);
    return l.length === 1 ? `L'issue ${l[0]}` : `Les issues ${listeEt(l, ' ; ')}`;
};
/** Même chose en fin de phrase : « l'événement constitué des issues 3 ; 4 ; 5 et 6 ». */
const evenementIssues = (ens) => {
    const l = trie(ens);
    return l.length === 1 ? `l'événement constitué de l'issue ${l[0]}` : `l'événement constitué des issues ${listeEt(l, ' ; ')}`;
};

// L'exemple du cours (dé, « inférieur ou égal à 2 ») est réservé au coup de pouce.
const estExempleDuCours = (A, U) => U.N === 6 && A.code === 'infeg' && A.s === 2;

/**
 * Les distracteurs de la MÊME famille que A (ensembles d'issues), nommés :
 *   contraire_partiel    : le contraire avec une issue oubliée ;
 *   contraire_voisin     : le contraire de l'événement voisin (la borne
 *                          incluse, ou « ne pas obtenir » le numéro d'à côté) ;
 *   meme_sens            : (bornes) « inférieur » gardé, la borne exclue ;
 *   evenement_pour_issue : (numéro) une seule issue au lieu d'un événement.
 */
const distracteursContraire = (A, U) => {
    const C = complementDe(ensembleA(A, U), U);
    if (A.code === 'infeg') {
        const oubliee = randomChoice([A.s + 1, U.N]);
        return [
            { code: 'contraire_partiel', ens: C.filter((k) => k !== oubliee) },
            { code: 'contraire_voisin', ens: intervalle(A.s, U.N) },
            { code: 'meme_sens', ens: intervalle(1, A.s - 1) },
        ];
    }
    if (A.code === 'supeg') {
        const oubliee = randomChoice([1, A.s - 1]);
        return [
            { code: 'contraire_partiel', ens: C.filter((k) => k !== oubliee) },
            { code: 'contraire_voisin', ens: intervalle(1, A.s) },
            { code: 'meme_sens', ens: intervalle(A.s + 1, U.N) },
        ];
    }
    // egal x : le voisin x' (x + 1 ou x − 1). Le contraire partiel oublie
    // justement x', et l'issue seule est une autre issue z : la clé partage
    // alors autant d'issues avec les autres réponses que le contraire voisin
    // (sinon elle était la seule « au centre » des quatre, 35,9 % des tirages).
    const voisins = [A.x - 1, A.x + 1].filter((v) => v >= 1 && v <= U.N);
    const xv = randomChoice(voisins);
    const z = randomChoice(C.filter((k) => k !== xv));
    return [
        { code: 'contraire_partiel', ens: C.filter((k) => k !== xv) },
        { code: 'contraire_voisin', ens: intervalle(1, U.N).filter((k) => k !== xv) },
        { code: 'evenement_pour_issue', ens: [z] },
    ];
};

const tirerA = (U, types) => {
    for (let essai = 0; essai < 40; essai++) {
        const code = randomChoice(types);
        let A;
        if (code === 'infeg') A = { code, s: randInt(2, U.N - 3) };
        else if (code === 'supeg') A = { code, s: randInt(4, U.N - 1) };
        else if (code === 'egal') A = { code, x: randInt(1, U.N) };
        else A = { code };
        if (!estExempleDuCours(A, U)) return A;
    }
    return { code: 'egal', x: 3 };
};

const genContraireQcm = () => {
    for (let essai = 0; essai < 60; essai++) {
        const U = randomChoice(UNIVERS_CONTRAIRE);
        const A = tirerA(U, ['infeg', 'supeg', 'egal']);
        const C = complementDe(ensembleA(A, U), U);
        const distr = distracteursContraire(A, U);
        const options = [{ code: null, ens: C }, ...distr];
        // Second chemin : une seule option est le contraire (union = tout,
        // intersection vide avec A), quatre ensembles deux à deux différents et non vides.
        const ensA = ensembleA(A, U);
        const estContraire = (ens) => ens.every((k) => !ensA.includes(k)) && ens.length + ensA.length === U.N;
        if (options.filter((o) => estContraire(o.ens)).length !== 1 || !estContraire(C)) throw new Error('gen_166 : contraire');
        if (options.some((o) => !o.ens.length)) continue;
        if (new Set(options.map((o) => trie(o.ens).join(','))).size !== 4) continue;
        const choix = options.map((o) => issuesTexte(o.ens));
        const payload = makeQcm(choix, choix[0],
            `${U.intro}<p><b>Quel est l'événement contraire de l'événement « ${phraseA(A, U)} » ?</b></p>`,
            opts(L_CONTRAIRE));
        payload._meta.params = { N: U.N, A: phraseA(A, U), contraire: C, distracteurs: distr.map((d) => d.code) };
        return payload;
    }
    // Repli déterministe vérifié : dé, « obtenir le nombre 3 » ; contraire
    // 1 ; 2 ; 4 ; 5 ; 6 ; partiel sans 6, voisin sans 4, issue 4.
    const U = UNIVERS_CONTRAIRE[0];
    const choix = [[1, 2, 4, 5, 6], [1, 2, 4, 5], [1, 2, 3, 5, 6], [4]].map(issuesTexte);
    const payload = makeQcm(choix, choix[0],
        `${U.intro}<p><b>Quel est l'événement contraire de l'événement « obtenir le nombre 3 » ?</b></p>`,
        opts(L_CONTRAIRE));
    payload._meta.params = { N: 6, A: 'obtenir le nombre 3', contraire: [1, 2, 4, 5, 6], distracteurs: ['contraire_partiel', 'contraire_voisin', 'evenement_pour_issue'] };
    return payload;
};

/** Une ligne du V/F sur A : vraie (le contraire) ou fausse (une erreur nommée). */
const ligneContraire = (A, U, vraie) => {
    const debut = `Le contraire de « ${phraseA(A, U)} » est`;
    const C = complementDe(ensembleA(A, U), U);
    if (vraie) {
        if (A.code === 'pair' || A.code === 'impair') {
            return { texte: `${debut} « ${phraseA({ code: A.code === 'pair' ? 'impair' : 'pair' }, U)} ».`, ens: C, code: null };
        }
        if (A.code === 'egal') return { texte: `${debut} « ne pas obtenir le ${U.mot} ${A.x} ».`, ens: C, code: null };
        return { texte: `${debut} ${evenementIssues(C)}.`, ens: C, code: null };
    }
    if (A.code === 'pair' || A.code === 'impair') {
        const oubliee = randomChoice(C);
        const partiel = C.filter((k) => k !== oubliee);
        return { texte: `${debut} ${evenementIssues(partiel)}.`, ens: partiel, code: 'contraire_partiel' };
    }
    const d = randomChoice(distracteursContraire(A, U).filter((x) => x.code !== 'meme_sens'));
    if (A.code === 'egal' && d.code === 'evenement_pour_issue') {
        return { texte: `${debut} « obtenir le ${U.mot} ${d.ens[0]} ».`, ens: d.ens, code: d.code };
    }
    if (A.code === 'egal' && d.code === 'contraire_voisin') {
        const xv = complementDe(d.ens, U)[0];
        return { texte: `${debut} « ne pas obtenir le ${U.mot} ${xv} ».`, ens: d.ens, code: d.code };
    }
    return { texte: `${debut} ${evenementIssues(d.ens)}.`, ens: d.ens, code: d.code };
};

const genContraireVF = () => {
    for (let essai = 0; essai < 60; essai++) {
        const U = randomChoice(UNIVERS_CONTRAIRE);
        const nbV = randInt(1, 3);
        // Quatre événements de types différents (pair OU impair, pas les deux).
        const types = [randomChoice(['pair', 'impair']), 'egal', 'infeg', 'supeg'];
        const evenements = types.map((t) => tirerA(U, [t]));
        if (evenements.some((A) => estExempleDuCours(A, U))) continue;
        const verites = shuffle([...Array(nbV).fill(true), ...Array(4 - nbV).fill(false)]);
        const lignes = evenements.map((A, i) => ({ A, ...ligneContraire(A, U, verites[i]) }));
        if (lignes.some((l) => !l.ens.length)) continue;
        // Second chemin : la ligne est vraie si et seulement si son ensemble est le contraire.
        lignes.forEach((l, i) => {
            const vraie = memeEnsemble(l.ens, complementDe(ensembleA(l.A, U), U));
            if (vraie !== verites[i]) throw new Error(`gen_166 : ligne contraire « ${l.texte} »`);
        });
        const ordre = shuffle([0, 1, 2, 3]);
        const payload = makeVraiFaux(ordre.map((i) => lignes[i].texte), ordre.map((i) => (verites[i] ? 0 : 1)),
            `${U.intro}<p><b>Vrai ou faux ?</b></p>`, opts(L_CONTRAIRE));
        payload._meta.params = { N: U.N, nbV, distracteurs: lignes.filter((l) => l.code).map((l) => l.code) };
        return payload;
    }
    // Repli déterministe vérifié (dé) : pair → impair (vrai), 5 → ne pas obtenir 5
    // (vrai), ≤ 3 → 3 ; 4 ; 5 ; 6 (faux, contraire_voisin), ≥ 4 → 1 ; 2 ; 3 (vrai).
    const U = UNIVERS_CONTRAIRE[0];
    const lignes = [
        ['Le contraire de « obtenir un nombre pair » est « obtenir un nombre impair ».', 0],
        ['Le contraire de « obtenir le nombre 5 » est « ne pas obtenir le nombre 5 ».', 0],
        ['Le contraire de « obtenir un nombre inférieur ou égal à 3 » est l\'événement constitué des issues 3 ; 4 ; 5 et 6.', 1],
        ['Le contraire de « obtenir un nombre supérieur ou égal à 4 » est l\'événement constitué des issues 1 ; 2 et 3.', 0],
    ];
    const payload = makeVraiFaux(lignes.map((l) => l[0]), lignes.map((l) => l[1]), `${U.intro}<p><b>Vrai ou faux ?</b></p>`, opts(L_CONTRAIRE));
    payload._meta.params = { N: 6, nbV: 3, distracteurs: ['contraire_voisin'] };
    return payload;
};

// ═════════ Contrat des distracteurs (données pures, jamais lues à l'exécution) ═════════

export const REGLES_DISTRACTEURS_QCM = {
    issues_qcm_unique: {
        support: 'urne de 6 à 12 boules de deux couleurs, 3 à 6 numéros différents répétés, un numéro au moins manquant sous le plus grand, nombre de boules différent du plus grand numéro ; « Combien y a-t-il d\'issues si on s\'intéresse au numéro ? »',
        familles: {
            issues_comptees_en_boules: 'le nombre de boules pris pour le nombre d\'issues (la principale : l\'exemple de réussite a 12 boules et 5 issues)',
            couleur_pour_numero: 'le nombre d\'issues pour la couleur (2) donné à la place de celui pour le numéro',
            plus_grand_numero: 'les numéros comptés de 1 au plus grand, sans voir qu\'il en manque (le 3 de l\'exemple)',
        },
        garantie: 'quatre valeurs deux à deux distinctes par construction (2 < 3 ≤ k < plus grand numéro, k + 2 ≤ nombre de boules, boules ≠ plus grand numéro), vérifiées ; plus de boucle de complément',
        residuel: 'À ARBITRER : la clé est toujours la deuxième plus petite valeur ; parade possible, non appliquée faute d\'erreur attestée, une famille de valeur inférieure à la clé',
        supprimee: 'la variante « Pourquoi dit-on que ce tirage est une expérience aléatoire ? » : trois distracteurs absurdes, clé la plus longue',
    },
    issues_qcm_multiple: {
        support: 'la même urne ; « On s\'intéresse au numéro écrit sur la boule. Sélectionne les k issues possibles. » (le nombre annoncé, FORMATS_TANOED §2)',
        familles: {
            numero_absent: 'un ou deux numéros entre 1 et le plus grand qui ne sont sur aucune boule',
            couleur_pour_numero: 'une couleur (issue du critère couleur) cochée alors qu\'on s\'intéresse au numéro',
        },
        garantie: 'bonnes réponses = les numéros présents, relus boule par boule ; au plus huit choix',
    },
    nature_qcm_unique: {
        support: 'sac de N jetons (6 à 10) numérotés de 1 à N, de deux couleurs ; nature visée tirée d\'abord, un tiers chacune ; trois réponses fixes « Certain », « Impossible », « Ni certain ni impossible »',
        pieges: {
            certain_pour_tres_probable: 'événement auquel il ne manque qu\'une issue (« inférieur ou égal à N − 1 », « supérieur ou égal à 2 ») : dit certain (Eduscol 4e 2025 p. 19, DEPP 4e 2023 q.8)',
            impossible_pour_rare: 'événement d\'une seule issue (« obtenir le numéro 3 », « inférieur ou égal à 1 ») : dit impossible',
        },
        garantie: 'nature recalculée sur l\'ensemble des issues, identique sous la lecture stricte et la lecture large de « inférieur à » / « supérieur à » (throw sinon) ; « strictement » n\'est jamais écrit',
    },
    contraire_qcm_unique: {
        support: 'un dé à six faces, huit ou dix jetons ; A = « inférieur ou égal à s », « supérieur ou égal à s » ou « obtenir le numéro x » ; les quatre réponses données par leurs issues (forme du cours) ; l\'exemple du cours (dé, « inférieur ou égal à 2 ») jamais tiré',
        familles: {
            contraire_partiel: 'le contraire avec une issue oubliée (la principale) ; pour « obtenir le numéro x », c\'est le numéro d\'à côté qui est oublié',
            contraire_voisin: 'le contraire de l\'événement voisin : la borne incluse ({s ; …} pour « ≤ s »), ou « ne pas obtenir » le numéro d\'à côté',
            meme_sens: '(bornes) la même direction, la borne exclue : « inférieur à s » pour le contraire de « inférieur ou égal à s »',
            evenement_pour_issue: '(numéro) une seule issue du contraire au lieu d\'un événement, prise hors du numéro d\'à côté pour que la clé ne soit pas la seule réponse « au centre » des autres (35,9 % des tirages avant ce choix)',
        },
        garantie: 'une seule réponse est le contraire (intersection vide avec A, union = toutes les issues), vérifié ; quatre ensembles distincts et non vides, nouveau tirage sinon',
    },
    nature_tableau_vf: 'quatre événements différents (phrases distinctes), une ligne chacun, « … est certain. » ou « … est impossible. » ; une à trois vraies ; une fausse au moins est un piège nommé (certain_pour_tres_probable : il manque une ou deux issues, dit certain ; impossible_pour_rare : une seule issue, dit impossible), les autres tirées parmi les pièges restants et les événements ordinaires',
    contraire_tableau_vf: 'quatre événements de types différents (pair ou impair, un numéro, une borne basse, une borne haute) ; une à trois vraies ; fausses nommées contraire_partiel, contraire_voisin, evenement_pour_issue',
};

// ─── Registry & Export ───────────────────────────────────────

const GENERATORS = {
    issues_texte_trou_saisie: genIssuesSaisie,
    issues_qcm_multiple: genIssuesQcmMultiple,
    issues_qcm_unique: genIssuesQcm,
    nature_qcm_unique: genNatureQcm,
    nature_classer: genNatureClasser,
    nature_tableau_vf: genNatureVF,
    contraire_qcm_unique: genContraireQcm,
    contraire_tableau_vf: genContraireVF,
};

const FORMAT_LABELS = {
    qcm_unique: 'QCM', qcm_multiple: 'QCM Multi', texte: 'Saisie',
    texte_trou_drag: 'Drag', texte_trou_saisie: 'Saisie trous',
    relier: 'Relier', classer: 'Classer', tableau_vf: 'Vrai/Faux',
};
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter((k) => k.startsWith(`${prefix}_`))
        .map((k) => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));

export const CATEGORIES = [
    { id: 'issues', label: L_ISSUES, formatsList: buildFormats('issues') },
    { id: 'nature', label: L_NATURE, formatsList: buildFormats('nature') },
    { id: 'contraire', label: L_CONTRAIRE, formatsList: buildFormats('contraire') },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
